<template>
    <svg
        class="fill-current"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M27 9C27 7.89543 26.1046 7 25 7H7C5.89543 7 5 7.89543 5 9V23C5 24.1046 5.89543 25 7 25H25C26.1046 25 27 24.1046 27 23V9ZM25 13.4705V23H7L7 13.4703L15.4795 18.6408C15.7992 18.8357 16.2011 18.8357 16.5208 18.6408L25 13.4705ZM25 11.128V9L7 9V11.1279L16.0001 16.6158L25 11.128Z"
        />
    </svg>
</template>
